import { DEFAULT_CURRENCY } from '@shared/constants'

type CurrencyFormat = {
  amount?: string | number | null
  currency?: string | null
}

export const getFormatCurrency = ({ amount, currency }: CurrencyFormat) => {
  const editedAmount = amount ? Number(amount) : 0

  return editedAmount.toLocaleString('ro-RO', {
    style: 'currency',
    currency: currency || DEFAULT_CURRENCY
  })
}

export const SERIES_AND_NUMBER_REGEX = /^(?=.{7,10}$)([A-Z]{0,10})(\d{0,10})$/

export const normalizeSeriesAndNumber = (input?: unknown) =>
  typeof input === 'string' ? input.replace(/\s/g, '').toUpperCase() : ''

export const extractSeriesAndNumber = (input?: string | null) => {
  const document = normalizeSeriesAndNumber(input)

  const match = SERIES_AND_NUMBER_REGEX.exec(document)

  if (match)
    return {
      ...(match[1] && { series: match[1] }),
      number: match[2]
    }

  return null
}

export const validateCommission = (
  value: string | number | undefined | null,
  t: (key: string) => string
) => {
  if (value === '' || value === undefined || value === null) {
    return Promise.resolve()
  }
  const numValue = Number(value)
  if (isNaN(numValue)) {
    return Promise.reject(new Error(t('commission_max_value')))
  }
  if (numValue > 100) {
    return Promise.reject(new Error(t('commission_max_value')))
  }
  if (numValue < 0) {
    return Promise.reject(new Error(t('commission_min_value')))
  }
  return Promise.resolve()
}
